import { theme } from 'antd';
export var useAntdToken = function useAntdToken() {
  var _theme$useToken = theme.useToken(),
    token = _theme$useToken.token;
  return token;
};